"use client"

import { Users } from "lucide-react"
import { useState } from "react"

export const FasGallery = () => {

  const images = [
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/7-CAoOGfXssKI1twHWhB46Kbd5PLRnQA.jpg",
      caption: "Community Gathering",
      description: "Bringing together volunteers and students for educational outreach programs in local communities",
      location: "Philippines",
      impact: "200+ Students Reached",
      category: "Community"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/10-bm54L56NTTtzMTy04UyCqPZ8l8rtBa.jpg",
      caption: "Classroom Impact",
      description: "Interactive learning sessions with dedicated volunteers and eager students",
      location: "Philippines",
      impact: "150+ Students Engaged",
      category: "Education"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/3-fQK2a5YBtJkZd7mmMFKSyASwhsVsux.jpg",
      caption: "Distribution Day",
      description: "Volunteers distributing essential school supplies to eager young minds",
      location: "Philippines",
      impact: "500+ Supplies Distributed",
      category: "Distribution"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/2-YhHVF9fs7OjPEpGMCLMGdg7PjPQvkj.jpg",
      caption: "Empowering Students",
      description: "Young students receiving educational materials and life-changing support",
      location: "Philippines",
      impact: "300+ Lives Touched",
      category: "Education"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/1-jIBQsBsVtriekGBRX7C3kok9oJFcS7.jpg",
      caption: "Community Outreach",
      description: "Building lasting connections with families and local community leaders",
      location: "Philippines",
      impact: "50+ Families Supported",
      category: "Outreach"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/4-OCb3KMziWRStLztmTRMrcwi912iDzz.jpg",
      caption: "Preparing for Impact",
      description: "Dedicated volunteers organizing and preparing educational materials for distribution",
      location: "Philippines",
      impact: "1000+ Items Prepared",
      category: "Distribution"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/9-UpM84FfiOZHJ2CaygjnM8u0PzttkNN.jpg",
      caption: "Team Unity",
      description: "Volunteers and community members working together toward educational excellence",
      location: "Philippines",
      impact: "100+ Volunteers United",
      category: "Community"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/8-UnN0vFH6K269AcWPNS5gv5Hquug9TW.jpg",
      caption: "Ready to Learn",
      description: "Excited students eager to begin their educational journey with new supplies",
      location: "Philippines",
      impact: "400+ Students Inspired",
      category: "Education"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/5-TQIfuC6EVdKLdRtCBogYelDs0ZND3X.jpg",
      caption: "Mountain Communities",
      description: "Bringing hope and educational resources to remote mountainous regions",
      location: "Philippines",
      impact: "25+ Remote Areas Reached",
      category: "Outreach"
    },
    {
      url: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/6-mNzsaIP848kJdFxmBm8QM6mtIMb9P7.jpg",
      caption: "Feeding Programs",
      description: "Nourishing both minds and bodies through comprehensive support programs",
      location: "Philippines",
      impact: "800+ Meals Provided",
      category: "Community"
    },
  ]

  const categories = ["All", "Education", "Community", "Distribution", "Outreach"]
  const [activeCategory, setActiveCategory] = useState("All")

  const filteredImages = activeCategory === "All" 
    ? images 
    : images.filter(img => img.category === activeCategory)

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16 animate-in fade-in duration-700">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-6 py-3 rounded-full text-sm mb-6 font-semibold shadow-sm border border-amber-200">
            <span className="w-2 h-2 bg-amber-600 rounded-full animate-pulse"></span>
            Stories from the Communities We Serve
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Our Impact Gallery
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Witness the transformative power of education and community support through our visual stories of hope and empowerment
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex justify-center mb-12 animate-in slide-in-from-top duration-700" style={{ animationDelay: '200ms' }}>
          <div className="flex flex-wrap gap-2 sm:gap-3 p-2 bg-white rounded-xl shadow-lg border border-gray-200">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium text-sm sm:text-base transition-all duration-300 ${
                  activeCategory === category
                    ? "bg-amber-600 text-white shadow-md transform scale-105"
                    : "bg-gray-100 text-gray-700 hover:bg-amber-100 hover:text-amber-700"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {filteredImages.map((image, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 animate-in slide-in-from-bottom duration-700"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={image.url || "/placeholder.svg"}
                  alt={image.caption}
                  className="w-full h-64 sm:h-72 object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-md">
                    {image.category}
                  </span>
                </div>

                {/* Overlay Actions removed as requested */}
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1 h-6 bg-amber-600 rounded-full"></div>
                  <span className="text-sm font-semibold text-amber-700 uppercase tracking-wide">{image.location}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-700 transition-colors duration-300">
                  {image.caption}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {image.description}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-amber-700">
                    <Users className="w-4 h-4" />
                    <span className="text-sm font-semibold">{image.impact}</span>
                  </div>
                  <button 
                    onClick={() => {
                      // Could open modal or navigate to detailed view
                      // Future: implement image detail view
                    }}
                    className="text-amber-600 hover:text-amber-700 font-medium text-sm hover:underline transition-all duration-300"
                  >
                    Learn More →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Facebook Page Plugin - Follow Us Section */}
        <div className="text-center animate-in fade-in duration-700" style={{ animationDelay: '800ms' }}>
          <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 border border-gray-100 max-w-4xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="p-3 bg-blue-600 rounded-xl shadow-lg">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </div>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Follow Our Journey
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Stay connected with our latest activities, events, and impact stories from the Fly and Share community
            </p>
            
            {/* Facebook Page Plugin */}
            <div className="flex justify-center mb-8">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div
                  className="fb-page"
                  data-href="https://www.facebook.com/TWIflyandshare"
                  data-width="700"
                  data-adapt-container-width="true"
                  data-hide-cover="true"
                  data-show-facepile="true"
                ></div>
              </div>
            </div>

            <a
              href="https://www.facebook.com/TWIflyandshare"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 text-white font-bold rounded-xl shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              See More on Facebook
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
